import { numberMoney } from 'Data/format.js'

export function getAmount(item) {
  return numberMoney(
    Math.abs(item.entries.reduce((acc, entry) => acc + entry.amount, 0))
  )
}

export function getDescription(item) {
  return item.entries
    .map(
      entry =>
        `${getAdjustmentName(entry)} (${numberMoney(Math.abs(entry.amount))})`
    )
    .join(' + ')
}

function getAdjustmentName(transaction) {
  switch (transaction.dtype) {
    case 'WriteOff':
      return 'Write off'
    case 'DiscountAdjustment':
      return `${transaction.discount_adjustment.discount.name || 'Discount'}${transaction.discount_adjustment.discount_reverse_adjustments.length > 0 ? ' - Reversed' : ''}`
    default:
      return transaction.dtype
  }
}
